import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Divider,
  Link,
} from '@material-ui/core';

import Alert from '@mui/material/Alert';

import { ClipboardCopyInput } from '../ClipboardCopyInput';

type CopyTokenDialogProps = {
  open: boolean;
  name: string;
  token: string;
  tokenDuration: string;
  urls?: string[];
  handleClose: () => void;
};

export const CopyTokenDialog = (props: CopyTokenDialogProps) => {
  const { open, token, name, tokenDuration, urls = [], handleClose } = props;

  return (
    <Dialog
      data-testid="copy-token-dialog"
      open={open}
      onClose={handleClose}
      aria-labelledby="copy-token-title"
    >
      <DialogTitle id="copy-token-title">Token Generated With Success</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Copy the token below to access {name}.
        </DialogContentText>
        <ClipboardCopyInput text={token} />
        <Typography variant="caption" display="block" gutterBottom>
          Note: this token expires in {tokenDuration}.
        </Typography>
        <Alert severity="warning">
          Make sure you copy the above token now. We don't store it and you
          will not be able to see it again.
        </Alert>
        {urls.length > 0 && (
          <>
            <Divider style={{ margin: '10px 0px' }} />
            <DialogContentText>
              Beyond the token, you may also want to use some of these access
              URLs:
            </DialogContentText>
            <ul style={{ wordWrap: 'break-word' }}>
              {urls.map((url: string, index: number) => (
                <li key={index}>
                  <Link href={url} variant="body2" target="_blank">
                    {url}
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
